import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bd5c8262&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bd5c8262&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5c8262",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd5c8262')) {
      api.createRecord('bd5c8262', component.options)
    } else {
      api.reload('bd5c8262', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bd5c8262&scoped=true", function () {
      api.rerender('bd5c8262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/merchant/divisionConfig/index.vue"
export default component.exports